/* global __webpack_public_path__:writable */

import 'base-styles/reset.sss';
import 'base-styles/global.sss';

import 'utils/polyfill';

// babel-polyfill was imported after because it was using the old commonJS require syntax
// All the `import` are parsed before actually executing the file, but require is done at execution
// So it was importing all the components then the polyfill
// The issue is some component (e.g. renderedPixel) have Object.assign in their body
// And they end up executed before the polyfill
// Using import make it executed in the correct order
// import 'babel-polyfill';

// No requestAnimationFrame polyfill in babel-polyfill apparently
import 'utils/rafPolyfill';

import { h, render } from 'preact';
import { buildClientStoreData } from 'utils/clientUtils';
import ShowtimesApp from 'base/showtimes/showtimesApp';
import 'store/update';
// import 'store/updateShowtimes'; // imported from showtimes page to avoid loading unecessary code for home-only sites
// import 'store/updateTicketing';
import 'utils/historyPushEvent'; // Add events for when you do history.push
import 'utils/hacks';

try {
	let url = location.origin + location.pathname.replace(/\/[^/]*$/, '/');
	__webpack_public_path__ = url + (window.__RELATIVE_ROOT__ || '');
} catch (e) {}

/* Setting up the store
-----------------------------*/

let initialState = window.__INITIAL_STATE__;
let initialStore = buildClientStoreData(initialState);

if (window.__START_PAGE_ID__) {
	initialState.activePage = initialState.appData.pages[window.__START_PAGE_ID__];
	// Also update the background state of the new page
	initialState.background = {
		videoPlaying: initialState.activePage.data ? initialState.activePage.data.allowBgVideo : true,
		videoEnabled: initialState.activePage.data ? initialState.activePage.data.allowBgVideo : true
	};
}


/* Initial render of the app
----------------------------------*/
// import(/* webpackChunkName: "babel-polyfill" */ 'babel-polyfill').then(() => {
// 	let elem = document.getElementById('app') || document.body;
// 	render(<ShowtimesApp initialStore={initialStore} />, elem, elem.firstChild);
// });

let elem = document.getElementById('app') || document.body;
render(<ShowtimesApp initialStore={initialStore} />, elem, elem.firstChild);
